import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {UrlHelperService} from '../../services/url-helper.service';
import {DetachedWidgetPageDefinition} from './detached-widget-def';

export interface WidgetPageParams {
    encodedWidgetsSettings: string;
}

@Injectable()
export class DetachedWidgetPageDefResolverService {

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): DetachedWidgetPageDefinition {
        return UrlHelperService.decodeDataFromBase64<DetachedWidgetPageDefinition>(
            (route.params as WidgetPageParams).encodedWidgetsSettings
        );
    }
}
